import React from 'react'

interface Props {
    description?: string;
    resources?: { id: string; label: string; urlToDownload: string; }[];
}

export const LessonResourcesDownload = (props: Props) => {

    return (
        <div className='space-y-6'>
            {props.description !== undefined && (
                <div className='text-white text-base break-words'>
                    {props.description}
                </div>
            )}
            {props.resources !== undefined && (
                <div className='space-y-4'>
                    {props.resources.map(resource => (
                        <a href={resource.urlToDownload} target='_blank' key={resource.id} className='bg-white flex flex-nowrap items-center justify-between p-5 rounded-xl select-none cursor-pointer space-x-2'>
                            <div className='break-words min-w-0'>{resource.label}</div>
                            <div>
                                <svg className='w-[24px] h-[24px]' fill="none" viewBox="0 0 32 32">
                                    <g clipPath="url(#a)">
                                        <path d="m32 30c0 1.1046-0.8954 2-2 2h-28c-1.1046 0-2-0.8954-2-2s0.89544-2 2-2h28c1.1046 0 2 0.8954 2 2zm-17.414-6.3358c0.3906 0.3906 0.9023 0.5859 1.4142 0.5859 0.5117 0 1.0238-0.1954 1.4142-0.5859l7.0861-7.086c0.7811-0.7811 0.7811-2.0474 0-2.8284-0.7811-0.7811-2.0474-0.7811-2.8284 0l-3.6719 3.6718v-15.422c0-1.1046-0.8954-2-2-2s-2 0.89544-2 2v15.422l-3.6719-3.6718c-0.78104-0.7811-2.0474-0.7811-2.8284 0-0.78106 0.781-0.78106 2.0473 0 2.8284l7.0861 7.086z" fill="#30B0EA" />
                                    </g>
                                    <defs>
                                        <clipPath id="a">
                                            <rect width="32" height="32" fill="#fff" />
                                        </clipPath>
                                    </defs>
                                </svg>

                            </div>
                        </a>
                    ))}
                </div>
            )}
        </div>
    );
};